import React from 'react';

import logo from '../img/logo.svg';

const Logo = ({ className, width = 133, height = 90 }) => (
  <img
    src={logo}
    width={width}
    height={height}
    alt="Dora Logo"
    className={className}
  />
);

export default Logo;



// WEBPACK FOOTER //
// ./src/common/Logo.js